"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSignedInUsingCookie = exports.setCookie = exports.getCookie = void 0;
const SIGN_IN_COOKIE = 'klear_logged_in';
function getCookie(name) {
    if (typeof window !== "undefined" && window.document) {
        const cookie = document.cookie
            .split('; ')
            .find(row => row.startsWith(name));
        if (cookie)
            return cookie.split('=')[1];
        // const value = "; " + document.cookie;
        // const parts = value.split("; " + name + "=");
        // if (parts.length === 2) return parts.pop()!.split(";").shift();
    }
}
exports.getCookie = getCookie;
function setCookie(name, value, days) {
    if (typeof window !== "undefined" && window.document) {
        let expires = "";
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/; domain=" + window.location.hostname.replace(/^www./, '');
    }
}
exports.setCookie = setCookie;
function isSignedInUsingCookie() {
    return getCookie(SIGN_IN_COOKIE);
}
exports.isSignedInUsingCookie = isSignedInUsingCookie;
//# sourceMappingURL=cookies.js.map